import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import HomePage from './pages/home';
import CustomerManagementPage from './pages/admin/customers';
import ReceiptAnalysisPage from './pages/admin/receipt-analysis';
import BookingPage from './pages/booking';
import BookingConfirmationPage from './pages/booking-confirmation';
import DashboardPage from './pages/dashboard';
import LoginPage from './pages/login';
import SignUpPage from './pages/signup';
import VerifyPage from './pages/verify';
import ForgotPasswordPage from './pages/forgot-password';
import ResetPasswordPage from './pages/reset-password';
import CouponPage from './pages/coupon';
import POSRoutes from './pages/pos';
import ReceiptTestPage from './pages/receipt-test';
import { AuthProvider } from '../hooks/use-auth';
import { WebSocketProvider } from '../hooks/use-websocket';
import { Toaster } from '@/components/ui/toaster';
import { ThemeProvider } from '../components/theme-provider';
import DemoBanner from '../components/DemoBanner';
import { useUiTheme } from '../hooks/use-ui-theme';
function AppRoutes() {
    const navigate = useNavigate();
    const { uiTheme } = useUiTheme();
    // redirect to home on auth-expired
    React.useEffect(() => {
        const onExpired = () => navigate('/', { replace: true });
        window.addEventListener('auth-expired', onExpired);
        return () => window.removeEventListener('auth-expired', onExpired);
    }, [navigate]);
    return (_jsxs("div", { className: "kg-theme-root", "data-ui-theme": uiTheme, children: [_jsx(DemoBanner, {}), _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(HomePage, {}) }), _jsx(Route, { path: "/admin/customers", element: _jsx(CustomerManagementPage, {}) }), _jsx(Route, { path: "/admin/receipt-analysis", element: _jsx(ReceiptAnalysisPage, {}) }), _jsx(Route, { path: "/booking", element: _jsx(BookingPage, {}) }), _jsx(Route, { path: "/booking/confirmation/:id", element: _jsx(BookingConfirmationPage, {}) }), _jsx(Route, { path: "/dashboard", element: _jsx(DashboardPage, {}) }), _jsx(Route, { path: "/pos/*", element: _jsx(POSRoutes, {}) }), _jsx(Route, { path: "/login", element: _jsx(LoginPage, {}) }), _jsx(Route, { path: "/signup", element: _jsx(SignUpPage, {}) }), _jsx(Route, { path: "/verify", element: _jsx(VerifyPage, {}) }), _jsx(Route, { path: "/forgot-password", element: _jsx(ForgotPasswordPage, {}) }), _jsx(Route, { path: "/reset-password", element: _jsx(ResetPasswordPage, {}) }), _jsx(Route, { path: "/receipt-test", element: _jsx(ReceiptTestPage, {}) }), _jsx(Route, { path: "/coupon/:code", element: _jsx(CouponPage, {}) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/", replace: true }) })] }), _jsx(Toaster, {})] }));
}
export default function App() {
    console.log(process.env.REACT_APP_API_BASE);
    return (_jsx(ThemeProvider, { attribute: "class", defaultTheme: "dark", enableSystem: false, children: _jsx(AuthProvider, { children: _jsx(WebSocketProvider, { children: _jsx(BrowserRouter, { children: _jsx(AppRoutes, {}) }) }) }) }));
}
